import React, { useContext } from 'react';
import { Stack } from '@solvhealth/jigsaw-v1';
import styled from 'styled-components';
import Requirements from '../Requirements';
import { safeGet } from '../../../../../../core/util/object';
import LocationPerforming from '../LocationPerforming';
import SampleAnalysis from '../SampleAnalysis';
import { LocationContext } from '../../../../ContextProviders';
import { StyledText, StyledUl } from '../../CSSstyles';
import { colors } from '~/constants/colors';
import { fontFamily } from '../../../../../../constants/text';

const StyledTestTitleSquid = styled(StyledText).withConfig({ componentId: 'sc-18vs58u-0' })`
  font-weight: 500 !important;
  color: ${colors.squid} !important;
  font-family: ${fontFamily.medium} !important;
`;

type Props = {
  testDetails?: any;
  testType: string;
};

const CovidTestSection = (props: Props) => {
  const { testDetails, testType } = props;
  const { location } = useContext(LocationContext);
  const { displayNamePrimary, displayNameSecondary } = location;

  const questionDetails = [
    {
      title: `How do I get a COVID test at ${displayNamePrimary} ${displayNameSecondary}?`,
      key: `${testType}-requirements`,
      answerComponent: (
        <Requirements requirements={safeGet(testDetails)('requirements')} testType={testType} />
      ),
    },
    {
      title: 'Where and how is the test done?',
      key: `${testType}-location`,
      answerComponent: (
        <LocationPerforming
          location={location}
          locationPerforming={safeGet(testDetails)('locationPerforming')}
          testType={testType}
        />
      ),
    },
    {
      title: 'When and how will I get the results?',
      key: `${testType}-analysis`,
      answerComponent: <SampleAnalysis details={testDetails} />,
    },
  ];

  return (
    <>
      <Stack space={3}>
        {questionDetails.map((question) => {
          return (
            <Stack key={question.key} space={0.5}>
              <StyledTestTitleSquid>{question.title}</StyledTestTitleSquid>
              <StyledUl>{question.answerComponent}</StyledUl>
            </Stack>
          );
        })}
      </Stack>
    </>
  );
};

export default CovidTestSection;
